<script>
import datePicker from "@alireza-ab/vue-persian-datepicker";
import { dateFormat, formatDateToEn, addTime } from "../../../Helpers/tools";
import { clocksList } from "../../../Constants";

// select html tag
const root = document.getElementsByTagName("html")[0];

export default {
  components: {
    datePicker,
  },

  props: {
    value: {
      type: Array,
      default: [],
      required: false,
    },

    type: {
      type: String,
      isRequired: true,
    },

    minDate: {
      type: String,
      isRequired: false,
      default: dateFormat(new Date(), "YYYY/MM/DD", "en"),
    },

    // maxDate: {
    //   type: String,
    //   isRequired: false,
    //   default: addTime(new Date(), 10),
    // },

    selectionMode: {
      type: String,
      default: "single",
      validator: (val) => ["single", "range"].includes(val),
    },

    label: {
      type: String,
      isRequired: false,
      default: "تاریخ",
    },

    secondLabel: {
      type: String,
      isRequired: false,
      default: "تاریخ دوم",
    },

    placeholder: {
      type: String,
      isRequired: false,
      default: "انتخاب تاریخ",
    },

    secondPlaceholder: {
      type: String,
      isRequired: false,
      default: "انتخاب تاریخ دوم",
    },

    onChangeValue: {
      type: Function,
      isRequired: false,
      default: null,
    },

    dateTime: {
      type: Boolean,
      required: false,
      default: false,
    },

    showSecondDate: {
      type: Boolean,
      required: false,
      default: false,
    },

    index: {
      type: Number,
      required: false,
      default: null,
    },

    column: {
      type: Number,
      isRequired: false,
      default: 2,
    },
    focusDatePickerInput: {
      type: Boolean,
      isRequired: false,
      default: false,
    },
    errorLabel: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      date: "",
      rangeDate: [],
      error: null,
      isOpen: false,
      currentLocale: null,
      selectTimeIsOpen: false,
      selectedHour: null,
    };
  },

  computed: {
    todaysDate() {
      let format = this.currentLocale === "en" ? "d MMMM" : "jD jMMMM";
      return dateFormat(new Date(), format, this.currentLocale);
    },

    formattedDate() {
      let format = this.currentLocale === "en" ? "YYYY/MM/DD" : "jYYYY/jMM/jDD";
      if (this.selectionMode === "single") {
        return this.date
          ? dateFormat(typeof this.date === "string" ? this.date : this.date[0], format, this.currentLocale)
          : "";
      } else if (this.selectionMode === "range") {
        const tempDate = typeof this.date === "string" ? [this.date || "", ""] : [...this.date];
        return tempDate?.map((d) => (!!d ? dateFormat(d, format, this.currentLocale) : ""));
      }
    },

    localeMinDate() {
      return dateFormat(this.minDate || new Date());
    },

    isValid() {
      return !this.error;
    },

    activeClocksList() {
      // const now = new Date();
      // const currentMinutes = now.getHours() * 60 + now.getMinutes();

      return clocksList;
      // .filter(({ value }) => {
      //   const [hours, minutes] = value.split(":").map(Number);
      //   return hours * 60 + minutes >= currentMinutes;
      // });
    },

    columnsCount() {
      return window.innerWidth >= 993 ? this.column : 1;
    },
    dateFilled() {
      return this.selectionMode === "single" ? !!this.date : [...this.date].every(Boolean);
    },
    hasFormattedDate() {
      return this.selectionMode === "single" ? !!this.date : this.date.every?.(Boolean);
    },
  },

  methods: {
    goToday() {
      this.$refs.datepicker.goToToday();
    },

    confirm(fillNext) {
      this.error = null;

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }

      if (this.dateFilled) this.$refs.datepicker.submitDate(false);
      if (this.selectionMode === "range" && this.date.length === 2) this.$refs.datepicker.showDatePicker = false;
      if (this.dateTime) this.$refs.datepicker.submitDate();
      this.$emit("input", this.date);

      if (this.onChangeValue) this.onChangeValue(this.date);

      if (fillNext) this.$emit("fill-next-input");
    },

    setLocale(locale) {
      this.currentLocale = locale;
      this.$emit("changeLocale", locale);

      localStorage.setItem("dpf", locale);
    },

    changeLocale(locale) {
      let datepicker = this.$refs.datepicker;

      if (locale !== datepicker.currentLocale) {
        datepicker.changeLocale();

        this.setLocale(datepicker.currentLocale);
      }
    },

    select(date) {
      const formattedDate = this.currentLocale === "en" ? date.toString() : formatDateToEn(date.toString());
      if (this.selectionMode === "range") {
        const index = this.rangeDate.length > 0 ? 1 : 0;
        this.rangeDate[index] = formattedDate;
        this.$emit("input", [...this.rangeDate]);
      }

      if (this.selectionMode === "single") {
        //Setter of 'range' mode handle by submitDate of datepicker component using refs in confirm function
        this.date = formattedDate;
      }

      if (this.dateTime) {
        this.selectedHour = null;
        this.handleToggleSelectTime(true);
      } else if (this.dateFilled) this.confirm();
    },

    open() {
      this.setDefaultLocale();

      let datepicker = this.$refs.datepicker;

      if (this.localeMinDate && !this.date) {
        datepicker.changeSelectedYear(datepicker.fromDate.year());
        datepicker.changeSelectedMonth(datepicker.fromDate.month());
      }

      this.isOpen = true;

      if (this.currentLocale && this.currentLocale !== datepicker.currentLocale) datepicker.changeLocale();

      if (window.innerWidth < 993) {
        root.classList.add("no-scroll");
      }
    },

    close() {
      this.isOpen = false;
    },

    closeDatepicker() {
      this.$refs.datepicker.showDatePicker = false;

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }
    },

    handleOpen() {
      this.$nextTick(() => {
        this.$refs.datepicker.showPicker();
      });
    },
    focusDepartureDateDatePickerInput() {
      this.$refs.departureDate.showPicker(); // focus first date picker
    },
    handleResetValue(values = [null, null]) {
      this.date = [...values];
      this.$refs.datepicker.clear();
    },

    setDefaultLocale() {
      let datepickerFormat = localStorage.getItem("dpf");

      if (datepickerFormat) {
        this.currentLocale = localStorage.getItem("dpf");
      } else {
        this.currentLocale = "fa";

        localStorage.setItem("dpf", "fa");
      }
      this.$emit("currentLocale", this.currentLocale);
    },

    validate() {
      this.error = null;
      if (!this.date || this.date.length < (this.selectionMode === "range" ? 2 : 1)) {
        this.error = `${this.errorLabel || this.label} را انتخاب کنید`;
      } else if (this.dateTime && !this.selectedHour) {
        this.error = "ساعت را انتخاب کنید";
      }

      return this.isValid;
    },

    handleToggleSelectTime(status) {
      this.selectTimeIsOpen = status;
    },

    handleSelectTime(hour) {
      this.selectedHour = hour;
      this.$emit("handle-select-time", this.selectedHour);
      this.confirm();
    },

    focusInput() {
      this.$refs.datepicker.showPicker();
    },
  },

  mounted() {
    this.$refs.datepicker.$el.querySelector("input").inputMode = "none";
    if (this.selectionMode === "range") this.date = this.value?.every(Boolean) ? [...this.value] : ["", ""];
    else this.date = this.value || "";
  },

  created() {
    this.setDefaultLocale();
  },
};
</script>

<template>
  <div class="booking__date booking__date--lg">
    <div :class="['booking__item', isOpen && 'is-open']">
      <div class="booking__input" :class="{ 'is-invalid': error }">
        <label class="booking__input-label"> {{ label }} </label>
        <span
          class="booking__input-value"
          :class="{
            'is-placeholder': !hasFormattedDate,
            'fa-font': currentLocale === 'fa',
          }"
        >
          {{
            hasFormattedDate
              ? `${selectionMode === "single" ? formattedDate : formattedDate[0]} ${selectedHour || ""}`
              : placeholder
          }}
        </span>

        <date-picker
          v-model="date"
          locale="fa,en"
          :from="localeMinDate"
          :to="maxDate"
          :column="columnsCount"
          :mode="selectionMode"
          ref="datepicker"
          :class="currentLocale === 'fa' && 'fa-font'"
          class="booking__datepicker"
          :autoSubmit="!dateTime"
          @select="select"
          @open="open"
          @close="close"
        >
          <template #icon />

          <template #right-arrow>
            <i :class="currentLocale === 'fa' ? 'icon-chevron-right' : 'icon-chevron-left'" />
          </template>

          <template #left-arrow>
            <i :class="currentLocale === 'fa' ? 'icon-chevron-left' : 'icon-chevron-right'" />
          </template>

          <template #footer>
            <div class="booking__item-header hide-in-desktop">
              <span>{{ placeholder }}</span>

              <button class="icon-close" @click="closeDatepicker" />
            </div>

            <div class="booking__date-header dir-rtl">
              <ul class="booking__locale w-100">
                <li
                  :class="['btn btn-steel-blue btn--very-sm btn--rounded', currentLocale === 'fa' && 'active']"
                  @click="changeLocale('fa')"
                >
                  شمسی
                </li>

                <li
                  :class="['btn btn-steel-blue btn--very-sm btn--rounded', currentLocale === 'en' && 'active']"
                  @click="changeLocale('en')"
                >
                  میلادی
                </li>

                <li class="btn btn-steel-blue btn--very-sm btn--rounded mr--auto" @click="goToday" title="برو به امروز">
                  برو به امروز
                </li>
              </ul>
            </div>

            <div class="booking__dp-footer">
              <div v-if="dateTime" class="booking__dp-time">
                <div
                  @click="handleToggleSelectTime(!selectTimeIsOpen)"
                  :class="['booking__dp-time-list', selectTimeIsOpen && 'is-open']"
                >
                  <div>
                    <span>ساعت حرکت: </span>

                    <span>{{ selectedHour }}</span>
                  </div>

                  <ul :class="['custom-scroll-bar', currentLocale === 'fa' && 'fa-font']">
                    <li
                      v-for="hour in activeClocksList"
                      :key="hour.value"
                      @click="handleSelectTime(hour.value)"
                      :class="selectedHour === hour.value && 'is-selected'"
                    >
                      {{ hour.label }}
                    </li>
                  </ul>
                </div>
              </div>

              <div v-else class="booking__dp-footer-title">
                <span>امروز:</span>

                <span>
                  {{ todaysDate }}
                </span>
              </div>

              <button class="btn btn-teal" @click="confirm" title="تائید">تائید</button>
            </div>
          </template>
        </date-picker>
      </div>

      <label v-if="error" class="booking__item-validation">{{ error }}</label>
    </div>
    <div
      :class="['booking__item', isOpen && 'is-open']"
      v-if="selectionMode === 'range' && showSecondDate"
      @click="handleOpen"
    >
      <div class="booking__input" :class="{ 'is-invalid': error }">
        <label class="booking__input-label">{{ secondLabel }}</label>
        <span
          :class="['booking__input-value', !formattedDate[1] && 'is-placeholder', currentLocale === 'fa' && 'fa-font']"
        >
          {{ formattedDate[1] ? formattedDate[1] : secondPlaceholder }}
        </span>
      </div>
    </div>
  </div>
</template>
<style></style>
